module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAMAAAC+LeqSAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJXRSTlMAzMJ5S5fGv7ano56SjHxyU0IuKSIeDbqAVjQYBgJsZl5GPjwKnAjJEQAAAKlJREFUKM9t0lcSwyAMRVELNzDBvcUlff9rjKU/HujzzDAMVyRJa9ycwGREpBFTuqYCHBVrDjoQzwr6EW3wLtEH6F20BU1Fu6huoE50AM0Zy9HHo2JdIMOpWPXp616yWsxAsQy9aA3aLawv0IbxBmlUGGEjnhRyh4enIrS5CFf4M2z68NBKpT0sR5Nnq1jvWS32jWwzi+z96dkbfghEhMe5yDewGFspZcD+zHEF+u9aDm8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mobile/you.png
// module id = jkH1
// module chunks = 1